module.exports = __webpack_public_path__ + "img/japan.f8dc0f04.svg";